






















import { Component, Prop, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'
import { masker } from '@/utils'

@Component
export default class AtomInputText extends ComponentVue {
  @Ref()
  atomInputText!: any

  @Prop({ type: String })
  id!: string

  @Prop({ type: String })
  name!: string

  @Prop({ type: String })
  value!: string

  @Prop({ type: Number })
  width!: number

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: Boolean })
  autofocus!: boolean

  @Prop({ type: Boolean, default: false })
  small!: boolean

  @Prop({ type: Boolean, default: false })
  large!: boolean

  @Prop({ type: String, default: '' })
  mask!: string

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  get styles(): object {
    const obj = {
      width: '100%',
      fontSize: ''
    }
    if (this.width !== undefined) {
      obj.width = this.width + 'px'
    }
    if (this.fontSizeType !== 'normal') {
      obj.fontSize = this.fontSize + 'px'
    }

    return obj
  }

  get classes(): object {
    return {
      small: this.small,
      large: this.large
    }
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  mounted(): void {
    if (this.autofocus) {
      this.focus()
    }
  }

  focus(): void {
    this.$nextTick(() => {
      if (this.id) {
        const elem = document.getElementById(this.id)
        if (elem) {
          elem.focus()
        }
      }
    })
  }

  onInput(e: any) {
    if (e.target.value === null) e.target.value = ''

    if (this.mask) {
      const maskedValue = masker(e.target.value, this.mask, true)
      if (this.value === maskedValue) return

      this.$emit('input', maskedValue)
    } else {
      this.$emit('input', e.target.value)
    }
  }
}
